import { FormStepperValidationEvent, FormStepperValidationEventClientServerEnum, OrganismFormStepperEvents } from 'wolf/components/organisms/o-form-stepper/o-form-stepper.events';
import ControllerBase from '../../../../global/js/ControllerBase';
import { MoleculeFormProps } from '../m-form/m-form.data';
import { MoleculeFormEvents, MoleculeFormEventTypes } from '../m-form/m-form.events';
import { FormstepWarrantyStep2Events } from './m-formstep-warranty-step-2.events';
import controller from 'wolf/global/js/controller';
const formMolecule = require('components/molecules/m-form/m-form.template.twig') as any;

interface ComponentRefs {
	toggleAdditionalFields: 'toggleAdditionalFields',
	primaryForm: 'primaryForm',
	secondaryFormContainer: 'secondaryFormContainer',
	secondaryFormWrapper: 'secondaryFormWrapper',
}
export default class ControllerFormstepWarrantyStep2 extends ControllerBase<ComponentRefs> {

	private static readonly componentRefs: ComponentRefs = {
		toggleAdditionalFields: 'toggleAdditionalFields',
		primaryForm: 'primaryForm',
		secondaryFormContainer: 'secondaryFormContainer',
		secondaryFormWrapper: 'secondaryFormWrapper',
	};

	private additionFormEnabled: boolean = false

	/**
	 * The whole form is valid when:
	 * 1. All required fields for the first form are filled in and;
	 * 2a. The checkbox is not checked, or;
	 * 2b. The checkbox is checked and all required fields in secondary form are filled in
	 */
	private validationStates: Record<
		ComponentRefs['primaryForm'] | 'secondaryForm', boolean
	> = {
			primaryForm: false,
			secondaryForm: false,
		};

	private additionalFormData: MoleculeFormProps

	constructor(element: HTMLElement) {
		super(element, [], Object.values(ControllerFormstepWarrantyStep2.componentRefs));
		this.init();
		this.getFormConfig()
	}

	private init(): void {
		this.domNodeListenerEvents();
	}

	private handleToggle(event: MouseEvent | Event): void {
		// show or hide the billing form
		// const checkbox = event.target as HTMLInputElement | HTMLLabelElement;
		// show additional form...currenty done using uikit using toggle
		const input = event.target as HTMLInputElement
		this.additionFormEnabled = Boolean(input.checked)

		this.domUtils.toggleElementState(input, [this.additionFormEnabled ? 'uncheck' : 'check'])
		input.value = this.additionFormEnabled ? '1' : '0'

		if (this.additionFormEnabled) {
			this.domUtils.appendRawHtmlToDomElement(this.$references.secondaryFormWrapper, formMolecule({ data: this.additionalFormData, dataAttributes: { ref: 'secondaryForm' } }), 'beforeend')
			this.domUtils.toggleElementState(this.$references.secondaryFormContainer, ['show'])
			const additionalForm = document.querySelector('[data-ref="secondaryForm"]') as HTMLElement

			if (additionalForm) {
				new controller.ControllerControlledForm(additionalForm)
				// billing form:
				// listen for the managed form submitting new validation events when the child form validation state changes

				additionalForm.addEventListener(
					MoleculeFormEvents.VALIDATION_RAN,
					(e: CustomEvent<MoleculeFormEventTypes['VALIDATION_RAN']>) => this.updateChildFormValidity('secondaryForm', e)
				);
				const eventDetail: MoleculeFormEventTypes['RERUN_VALIDATION'] = true;
				this.dispatchCustomEvent(MoleculeFormEvents.RERUN_VALIDATION, eventDetail, false, false, additionalForm);
			}
		} else {
			this.domUtils.toggleElementState(this.$references.secondaryFormContainer, ['hide'])
			this.$references.secondaryFormWrapper.innerHTML = ''
			this.validateFormRequiredFields();
		}
	}

	/**
	 * Get additional form data to permits conditional render
	* @returns void
	*/
	private getFormConfig(): void {
		this.additionalFormData = this.domUtils.parseDOMScriptTag('ADDITIONAL_FORM_DATA');
	}

	/**
	 * @returns void
	 */
	private domNodeListenerEvents(): void {

		// listen for the o-form-stepper issuing external validation events
		// this will be when the user tries to advance to the next step
		window.addEventListener(FormstepWarrantyStep2Events.REQUEST_VALIDATION, (event: CustomEvent<FormStepperValidationEvent>) => {

			// validate the form and call success or error callback
			const formIsValid = this.validateFormRequiredFields();
			if (formIsValid) {
				if (event.detail.onValidationSuccess) event.detail.onValidationSuccess(FormStepperValidationEventClientServerEnum.Frontend);
			} else {
				if (event.detail.onValidationError) event.detail.onValidationError(FormStepperValidationEventClientServerEnum.Frontend);
			}
		});

		// shipping form:
		// listen for the managed form submitting new validation events when the child form validation state changes
		this.$references.primaryForm.addEventListener(
			MoleculeFormEvents.VALIDATION_RAN,
			(e: CustomEvent<MoleculeFormEventTypes['VALIDATION_RAN']>) => this.updateChildFormValidity(ControllerFormstepWarrantyStep2.componentRefs.primaryForm, e)
		);

		const checkboxMolecule = this.$references.toggleAdditionalFields as HTMLDivElement;

		if (checkboxMolecule) {
			checkboxMolecule.addEventListener('click', (e) => this.handleToggle(e));
		}
	}

	/**
	 * Updates internal validation status of the 2 forms
	 * @param  {ComponentRefs['primaryForm']|ComponentRefs['secondaryForm']} form
	 * @param  {CustomEvent<MoleculeFormEventTypes['VALIDATION_RAN']>} event
	 * @returns void
	 */
	private updateChildFormValidity(form: ComponentRefs['primaryForm'] | 'secondaryForm', event: CustomEvent<MoleculeFormEventTypes['VALIDATION_RAN']>): void {
		this.validationStates[form] = event.detail;

		this.validateFormRequiredFields();
	}

	/**
	 * Returns overall step validation based on checkbox
	 * @returns boolean
	 */
	private validateFormRequiredFields(): boolean {
		let formIsValid: boolean;

		if (this.additionFormEnabled) {
			formIsValid = this.validationStates.primaryForm && this.validationStates.secondaryForm;
		} else {
			formIsValid = this.validationStates.primaryForm;
		}

		this.dispatchCustomEvent(OrganismFormStepperEvents.DISABLE_GO_TO_NEXT_STEP, !formIsValid, false, true);
		return formIsValid;
	}
}
